import { Box, Button, Flex, Grid } from "@mantine/core";
import { useState } from "react";
import { repositoryMdm } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";
import { DatePickerInput } from "@mantine/dates";
import { IconCheck } from "@tabler/icons-react";
import { useDisclosure } from "@mantine/hooks";

const ModalTimeSync = ({ onSuccess }: { onSuccess: any }) => {
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const [fromDate, setFromDate] = useState<string | Date | null>(
    new Date(
      new Date(new Date().setHours(0, 0, 0, 0)).getTime() + 7 * 3600 * 1000,
    ).toISOString(),
  );
  const [toDate, setToDate] = useState<string | Date | null>(
    new Date(
      new Date(
        new Date(new Date().setDate(new Date().getDate() + 1)).setHours(
          0,
          0,
          0,
          0,
        ),
      ).getTime() +
        7 * 3600 * 1000,
    ).toISOString(),
  );

  const handleSyncVAT = async () => {
    open();

    const startDate = new Date(fromDate || "");
    const endDate = new Date(toDate || "");

    const maxAllowedDate = new Date(startDate);
    maxAllowedDate.setDate(startDate.getDate() + 4);

    if (endDate > maxAllowedDate) {
      NotificationExtension.Fails(
        "Chỉ được phép đồng bộ hóa đơn VAT trong khoảng 5 ngày !",
      );
      close();
      return;
    }

    try {
      const res = await repositoryMdm.post<MessageResponse<any>>(
        "/api/v1/SyncDataFromAsia/sync-invoice-soph3-to-order-header",
        {
          fromDate: fromDate,
          toDate: toDate,
        },
      );

      if (res && res.success) {
        NotificationExtension.Success("Đồng bộ hóa đơn VAT thành công !");
        setTimeout(() => {
          modals.closeAll();
          onSuccess();
        }, 1200);
      } else if (res && !res.success) {
        NotificationExtension.Fails(
          res?.message ||
            res?.data?.message ||
            "Đồng bộ hóa đơn VAT thất bại !",
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  return (
    <Box maw={600} w={"30vw"}>
      <Grid mt={10}>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <DatePickerInput
            label="Ngày bắt đầu"
            placeholder="Nhập ngày bắt đầu"
            locale="vi"
            valueFormat="DD/MM/YYYY"
            maxDate={toDate ? new Date(toDate) : undefined}
            value={fromDate ? new Date(fromDate) : null}
            onChange={(e) =>
              setFromDate(
                e
                  ? new Date(
                      new Date(e).getTime() + 7 * 3600 * 1000,
                    ).toISOString()
                  : null,
              )
            }
            withAsterisk
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <DatePickerInput
            label="Ngày kết thúc"
            placeholder="Nhập ngày kết thúc"
            locale="vi"
            valueFormat="DD/MM/YYYY"
            minDate={fromDate ? new Date(fromDate) : undefined}
            value={toDate ? new Date(toDate) : null}
            onChange={(e) =>
              setToDate(
                e
                  ? new Date(
                      new Date(e).getTime() + 7 * 3600 * 1000,
                    ).toISOString()
                  : null,
              )
            }
            withAsterisk
          />
        </Grid.Col>
      </Grid>
      <Flex mt={10} justify={"center"}>
        <Button
          loading={visible}
          disabled={visible || !fromDate || !toDate}
          leftSection={<IconCheck size={18} />}
          color="green"
          onClick={() => handleSyncVAT()}
        >
          Đồng bộ
        </Button>
      </Flex>
    </Box>
  );
};

export default ModalTimeSync;
